import * as React from 'react';

const SvgIconTrueGourmand = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={25} height={24} fill="none" {...props}>
    <path
      d="M2.25 9v13.5M20.247 15H22.5a.75.75 0 00.75-.748c.008-3.831.028-8.458-1.559-12.289a.75.75 0 00-1.443.287V22.5M.75 1.5v6A1.5 1.5 0 002.25 9v0a1.5 1.5 0 001.5-1.5v-6M16.5 8.283a7.173 7.173 0 00-9.744-.7M6 18.717a7.178 7.178 0 0010.5 0"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconTrueGourmand;
